import { ButtonCustomSizeConfig } from 'nanaykuna-ui-kit/loader';

/** Breakpoint where the access screens switch to the desktop card. */
export const ACCESS_DESKTOP_QUERY = '(min-width: 1024px)';

/** Primary action on desktop: 56px tall, 20px label. */
export const ACCESS_BUTTON_SIZE_DESKTOP: ButtonCustomSizeConfig = {
  height: 56,
  paddingX: 32,
  textType: 'p20',
  iconSize: 24,
};

/** Primary action below `lg`: 48px tall, 16px label. */
export const ACCESS_BUTTON_SIZE_MOBILE: ButtonCustomSizeConfig = {
  height: 48,
  paddingX: 24,
  textType: 'p16',
  iconSize: 20,
};
